import { observer } from 'mobx-react-lite'
import { type ScopeChangeCustomItemViewModel } from '@/features/jobs/details/components/RequestScopeChangesDialog/ListItems/ScopeChangeCustomItem/ScopeChangeCustomItemViewModel'
import {
  ScopeChangeCustomItemSelection,
  ScopeChangeCustomItemUpdateQuantity,
} from '@/features/jobs/details/components/RequestScopeChangesDialog/ListItems/ScopeChangeCustomItem'

export interface ScopeChangeCustomItemContainerProps {
  vm: ScopeChangeCustomItemViewModel
  onRemove: (key: string) => void
  updateQuantity?: boolean
  /**
   * Position of the item in the list, which the test IDs are keyed by.
   */
  position: number
}

export const ScopeChangeCustomItemContainer = observer(
  function ScopeChangeCustomItemContainer({
    vm,
    onRemove,
    updateQuantity,
    position,
  }: ScopeChangeCustomItemContainerProps) {
    const removeButtonTestId = `request-scope-changes-remove-button-${position}`
    if (updateQuantity) {
      return (
        <ScopeChangeCustomItemUpdateQuantity
          name={vm.name}
          quantity={vm.quantity}
          hasQuantityError={!!vm.validation.getError('quantity')}
          onRemove={() => onRemove(vm.key)}
          onQuantityChange={vm.setQuantity}
          removeButtonTestId={removeButtonTestId}
          quantityInputTestId={`scope-change-quantity-${position}`}
        />
      )
    }

    return (
      <ScopeChangeCustomItemSelection
        name={vm.name}
        hasNameError={!!vm.validation.getError('name')}
        onRemove={() => onRemove(vm.key)}
        onNameChange={vm.setName}
        removeButtonTestId={removeButtonTestId}
        nameInputTestId={`scope-change-name-${position}`}
      />
    )
  },
)
